import { apiClient } from "./apiClient";

export const authApi = {
  login: (credentials) => {
    return apiClient.post(process.env.REACT_APP_LOGIN_PATH, credentials);
  },

  refresh: (refreshToken) => {
    return apiClient.post(
      process.env.REACT_APP_REFRESH_PATH,
      {
        refresh_token: refreshToken,
      },
      {
        skipAuthRefresh: true,
      },
    );
  },

  register: (data) => {
    return apiClient.post(process.env.REACT_APP_REGISTER_PATH, data);
  },

  verifyOtp: (data) => {
    return apiClient.post(process.env.REACT_APP_VERIFY_OTP_PATH, data);
  },

  forgotPassword: (data) => {
    return apiClient.post(process.env.REACT_APP_FORGOT_PASSWORD_PATH, data);
  },

  verifyResetCode: (data) => {
    return apiClient.post(process.env.REACT_APP_VERIFY_RESET_CODE_PATH, data);
  },

  resetPassword: (data, options = {}) => {
    return apiClient.patch(
      process.env.REACT_APP_RESET_PASSWORD_PATH,
      data,
      options,
    );
  },

  logout: () => {
    return apiClient.post(process.env.REACT_APP_LOGOUT_PATH);
  },

  updateVerifyCode: (data) => {
    return apiClient.post(process.env.REACT_APP_UPDATE_VERIFY_CODE_PATH, data);
  },
};
